<div class="process-card">
  <div class="card-header text-center">
    <img
      src="assets/icons/avyna/logo.svg"
      [alt]="'backoffice.shell.logo_alt' | translate"
      class="brand-logo mb-3"
    />
    <h1 class="title-text">{{ 'backoffice.auth.callback.title' | translate }}</h1>
    <p class="subtitle-text mb-0">{{ 'backoffice.auth.callback.subtitle' | translate }}</p>
  </div>

  <div class="content-area d-flex flex-column justify-content-center">
    @if (hasError()) {
      <div class="error-view text-center d-flex flex-column align-items-center">
        <mat-icon class="error-icon">gpp_bad</mat-icon>
        <h2 class="error-title">{{ 'backoffice.auth.callback.failed' | translate }}</h2>
        <p class="error-desc">{{ errorMessage() | translate }}</p>

        <button
          mat-flat-button
          type="button"
          class="action-btn w-100 mt-4"
          (click)="returnToLogin()"
        >
          {{ 'backoffice.auth.callback.back' | translate }}
        </button>
      </div>
    } @else {
      <div class="progress-view d-flex flex-column gap-4">
        <div class="text-center">
          <span class="dynamic-message">{{ activeLabel() | translate }}</span>
        </div>

        <div class="w-100">
          <mat-progress-bar mode="determinate" [value]="progress()"></mat-progress-bar>
          <div class="progress-label text-end mt-1">{{ progress() | number: '1.0-0' }}%</div>
        </div>
      </div>
    }
  </div>

  <div class="card-footer d-flex align-items-center justify-content-center gap-2">
    <mat-icon class="secure-icon">lock</mat-icon>
    <span>{{ 'backoffice.auth.callback.secured' | translate }}</span>
  </div>
</div>
